import { getUserData } from "../assets/Js/tokenHandler";

export const useRoleFinder = () => {
  return () => getUserData()?.Role;
};
